import {FormBuilder} from '@angular/forms';
import {Component, Input} from '@angular/core';
import {InfoEntidadeForm} from './info-entidade.form';

@Component({
  selector: 'app-info-entidade',
  templateUrl: './info-entidade.component.html',
  styleUrls: ['./info-entidade.component.scss']
})
export class InfoEntidadeComponent {

  @Input() cnpj: string;
  @Input() razaoSocial: string;

  protected form: InfoEntidadeForm;

  constructor(private readonly formBuilder: FormBuilder) {
    this.form = new InfoEntidadeForm(formBuilder);
  }

}
